import axios from '@/lib/axios'
import { buildAdminRequestConfig, type OrganizationId } from '@/lib/organization-scoping'
import type { QueryFunctionContext } from '@tanstack/react-query'
import type { MerchandisingTagGroupsResponse } from './merchandising-tags.types'

export interface MerchandisingTagIndexQueryKeyEntries {
  organizationId: OrganizationId
}

export async function getMerchandisingTagGroups({
  queryKey: [{ organizationId }],
}: Pick<QueryFunctionContext<[MerchandisingTagIndexQueryKeyEntries]>, 'queryKey'>) {
  return (
    (
      await axios.get<MerchandisingTagGroupsResponse>(
        '/merchandising-tags',
        buildAdminRequestConfig({ organizationId })
      )
    )?.data ?? []
  )
}
